import React, { useEffect, useState, useRef } from "react";
import {
  IconId,
  IconMailForward,
  IconMail,
  IconFileText,
} from "@tabler/icons-react";
import Modal from "react-bootstrap/Modal";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";
import {
  Button,
  Table,
  Card,
  Col,
  Form,
  Row,
  InputGroup,
  FormText,
  textarea,
  Tab,
  Tabs,
  Spinner,
  ButtonGroup,
} from "react-bootstrap";
function EmailQuoteDialogOrder({
  username,
  order_id,
  //   Quote_No,
  show,
  setShow,
  setIsSuccsessModalOpen,
}) {
  const {
    data: EmailUSerData,
    // isLoading,
    postData: fetchEmails,
  } = usePostRequest(API_ENDPOINTS.EMAIL_ALL_USERS);

  const formRef = useRef(null);
  const { isLoading: sendLoading, postData: SendOrderEmail } = usePostRequest(
    API_ENDPOINTS.SEND_ORDER_EMAIL
  );

  const [errors, setErrors] = useState({
    comment: "",
    to_email: "",
  });

  // Validation function for comment field
  const validateComment = (comment) => {
    if (comment.trim() === "") {
      return "Comment is required.";
    }
    return "";
  };

  const handleCommentChange = (e) => {
    const comment = e.target.value;
    const commentError = validateComment(comment);
    setErrors({
      ...errors,
      comment: commentError,
    });

    setEmailData({
      ...emailData,
      comment,
    });
  };

  const onSuccess = (res) => {
    setIsSuccsessModalOpen({
      show: true,
      title: "Success",
      message: "Email Sent Successfully!",
      btntext: "Close",
    });
    setShow({ show: false });
  };

  const onError = (error) => {
    toast.error(error?.message);
  };

  const [emailData, setEmailData] = useState({
    order_id: order_id ? order_id : "",
    // invoice_no: Quote_No ? Quote_No : "",
    comment: "",
    to_username: username ? username : "",
    to_email: "",
  });

  const handleCancel = (e) => {
    e.preventDefault();
    setErrors({ ...errors, comment: "" });
    setEmailData({
      comment: "",
      to_email: "",
    });
    setShow({
      show: false,
    });
  };

  useEffect(() => {
    fetchEmails();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const commentError = validateComment(emailData.comment);
    if (commentError) {
      setErrors({ ...errors, comment: commentError });
      return;
    }

    if (!emailData.to_email) {
      setErrors({ ...errors, to_email: "Please select a user." });
      return;
    }

    setErrors({ ...errors, to_email: "" });
    SendOrderEmail(emailData, onSuccess, onError);
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow({ show: false })}
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="gap-2">
        <span className="avatar bg-pink-lt rounded-circle">
          <IconMailForward stroke={1.25} />
        </span>
        <div>
          <Modal.Title>Please Enter Recipient Details</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} ref={formRef}>
          <Form.Group className="mb-3">
            <Form.Label>ORDER ID</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconId stroke={1} />
              </InputGroup.Text>
              <Form.Control
                value={emailData.order_id}
                disabled
                onChange={(e) =>
                  setEmailData({ ...emailData, order_id: e.target.value })
                }
              />
            </InputGroup>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Select User Email ID</Form.Label>
            <Form.Select
              value={emailData.to_email || ""}
              onChange={(e) =>
                setEmailData({ ...emailData, to_email: e.target.value })
              }
              isInvalid={!!errors.to_email}
            >
              <option value="">Select User Email</option>
              {EmailUSerData?.data?.map((user, index) => (
                <option key={index} value={user.email}>
                  {user?.email}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.to_email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Comments</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                {" "}
                <IconFileText />{" "}
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                placeholder="Enter your comment..."
                rows={3}
                value={emailData.comment}
                onChange={handleCommentChange}
                isInvalid={!!errors.comment}
              />
            </InputGroup>
            <Form.Control.Feedback type="invalid">
              {errors.comment}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="warning"
          style={{ marginTop: "20px" }}
          onClick={() => formRef.current?.requestSubmit()}
        >
          {sendLoading ? (
            <Spinner as="span" size="sm" role="status" aria-hidden="true" />
          ) : (
            "Submit"
          )}
        </Button>

        <Button
          variant="outline-danger"
          style={{ marginTop: "20px" }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EmailQuoteDialogOrder;
